import { Component, OnInit, ViewChild } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ToastrService } from 'ngx-toastr';
import { RecaptchaComponent } from 'ng-recaptcha';

import { AuthService } from '../../../providers/auth/auth.service';
import { PurchaseService } from '../../../providers/purchase/purchase.service';

import { CustomerProvider } from '../../../providers/customer/customer';
import { HelpersProvider } from '../../../providers/helpers/helpers';

import { DialogLinkComponent } from '../../../ui/dialog-link/dialog-link';

import { environment } from '../../../environments/environment';


@Component({
  selector: 'component-customer-account',
  templateUrl: './account.component.html',
  styleUrls: ['./account.component.scss']
})
export class CustomerAccountComponent implements OnInit {
  @ViewChild('captchaRef') captchaRef!: RecaptchaComponent;

  user: any;
  subscription: any;
  premium_expiring = true;
  premium_expired = true;
  formSpinner = false;
  loading = false;
  loading_link = false;
  loading_prepaid = false;
  plan: number;
  link: string;
  product: any;
  environment: string = environment.dev;
  ENV: any = environment;
  recaptchaEnabled: boolean = environment.RECAPTCHA_ENABLED !== false;
  ismobile: boolean;
  payment_links: any;
  pagarme: any;

  captcha: string = null;

  accountName: string;

  cardFormOld = new FormGroup({
    supertreinos_plan_id: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
    cpf: new FormControl('', [Validators.required]),
    number: new FormControl('', [Validators.required]),
    cvv: new FormControl('', [Validators.required]),
    month_late: new FormControl('', [Validators.required]),
    year_late: new FormControl('', [Validators.required])
  });

  cardForm = new FormGroup({
    supertreinos_plan_id: new FormControl('', [Validators.required]),
    name: new FormControl('', [Validators.required]),
    cpf: new FormControl('', [Validators.required]),
    number: new FormControl('', [Validators.required]),
    cvv: new FormControl('', [Validators.required]),
    month_late: new FormControl('', [Validators.required]),
    year_late: new FormControl('', [Validators.required]),
    phone: new FormGroup({
      country_code: new FormControl('55', [Validators.required]),
      area_code: new FormControl('', [Validators.required]),
      number: new FormControl('', [Validators.required]),
    }),
    address: new FormGroup({
      country: new FormControl('BR', [Validators.required]),
      state: new FormControl('', [Validators.required]),
      city: new FormControl('', [Validators.required]),
      line_1: new FormControl('', [Validators.required]),
      line_2: new FormControl('', [Validators.required]),
      zip_code: new FormControl('', [Validators.required]),
    })
  });

  alert: any = {
    msg: <string> '',
    type: <string> '',
  };

  
  constructor(
    public auth: AuthService,
    public purchase: PurchaseService,
    public toastr: ToastrService,
    private customerProv: CustomerProvider,
    public dialog: MatDialog,
    private device: DeviceDetectorService,
    private helpers: HelpersProvider,
  ) {
    this.ismobile = this.device.isMobile();
    this.user = this.auth.retrieveLocalUser();
  }

  ngOnInit() {
    // console.log('ngOnInit');
    this.getPaymentList();
    this.getAccount();
  }

  handleCaptcha(token: string) {
    // this.captchaRef.execute();
    this.captcha = token;
    // console.log(token);
  }

  getAccount() {
    this.loading = true;
    this.auth.getCustomerLogin(this.user.email, this.user.password).then(
      (res: any) => {
        this.user = res.user;
        this.user.premium_expires_date = this.helpers.normalizeDate(this.user.premium_expires_date);
        this.loading = false;
        this.setPremiumExpiration();
        this.getSubscription();
      },
      (err: any) => {
        this.loading = false;
        this.toastr.error('Não foi possível retornar os dados da sua conta!', '', this.helpers.toastrCfgs);
        console.log(err);
      }
    );
  }

  getSubscription() {
    this.loading = true;
    // this.customerProv.getSubscription().then(
    this.purchase.getSubscription().then(
      (res: any) => {
        this.subscription = res.subscription;
        this.user.premium_expires_date = this.subscription.premium_expires_date;
        this.setPremiumExpiration();
        this.loading = false;

        if (this.user.pagarme_data === null || this.user.pagarme_data === '') return false;
        this.loading = true;
        this.purchase.getPagarme().then(
          (res: any) => {
            this.loading = false;
            // console.log(res);
            this.pagarme = res.pagarme;

            // formata o numego do cartão
            const numero = res.pagarme.card.first_six_digits + 'XXXXXX' + res.pagarme.card.last_four_digits;
            const formatado = numero.replace(/(.{4})/g, '$1 ').trim();
            // console.log(formatado);

            const data: any = {
              cpf: this.pagarme.customer.document,
              name: this.pagarme.card.holder_name,
              number: formatado,
              cvv: 'XXX',
              month_late: this.pagarme.card.exp_month,
              // year_late: this.pagarme.card.exp_year,
              year_late: (this.pagarme.card.exp_year).toString().substring(2),
              phone : {
                country_code: this.pagarme.customer.phones.mobile_phone.country_code,
                area_code: this.pagarme.customer.phones.mobile_phone.area_code,
                number: this.pagarme.customer.phones.mobile_phone.number,        
              },
              address: {
                country: this.pagarme.billing_address.country,
                state: this.pagarme.billing_address.state,
                city: this.pagarme.billing_address.city,
                line_1: this.pagarme.billing_address.line_1,
                line_2: this.pagarme.billing_address.line_2,
                zip_code: this.pagarme.billing_address.zip_code,
              }
            }
            this.cardForm.patchValue(data);
          },
          (err: any) => {
            this.loading = false;
            this.toastr.error('Não foi possível retornar os dados da sua assinatura!', '', this.helpers.toastrCfgs);
            console.log(err);
          }
        );
      },
      (err: any) => {
        this.loading = false;
        this.toastr.error('Não foi possível retornar os dados da sua assinatura!', '', this.helpers.toastrCfgs);
        console.log(err);
      }
    );
  }

  getSubsDetails() {
    // add_subscription_date: "2022-03-04 17:31:15"
    // cancel_subscription_date: "2022-03-22 19:31:39"
    // premium_expires_date: "2025-01-01 00:00:00"
    // prepaid_pagarme: []
    // subscription_apple: false
    // subscription_google: false
    // subscription_pagarme: false
    // console.log(this.subscription);
    if (this.subscription?.subscription_apple) {
      this.accountName = 'Premium Apple';
      return true;
    }
    if (this.subscription?.subscription_google) {
      this.accountName = 'Premium Google';
      return true;
    }
    if (this.subscription?.subscription_pagarme) {
      this.accountName = 'Premium Pagarme';
      return true;
    }
    if (this.subscription?.prepaid_pagarme.length > 0) {
      if (this.premium_expired === false) {
        this.accountName = 'Premium Pré-pago';
        return true;
      }
    }
    if (this.premium_expired === false && this.user.status === 1) {
      this.accountName = 'Premium Pré-pago';
      return true;
    }
    this.accountName = 'Conta Gratuita';
  }

  setPremiumExpiration() {
    const expire = new Date(this.user.premium_expires_date);
    const now = new Date();
    if ( (expire.getTime() - (10 * 24 * 60 * 60 * 1000 )) > now.getTime() ) {
      this.premium_expiring = false;
    } else {
      this.premium_expiring = true;
    }
    if (new Date(this.user.premium_expires_date) > new Date()) {
      this.premium_expired = false;
    }
    this.getSubsDetails();
  }

  gerarLinkPagamento(id: any) {
    // if (this.user.status === '1' || this.user.status === 1) {
    //   this.toastr.error('Cancele sua assinatura ou aguarde a expiração atual antes de assinar um plano pré-pago!');
    //   return false;
    // }
    this.plan = id;
    this.loading_link = true;
    this.purchase.getPaymentLink(id).then(
      (res: any) => {
        console.log(res);
        this.loading_link = false;
        this.link = res.purchase.url;
        this.product = res.purchase;
        this.getPaymentList();
        // window.open(res.purchase.url, '_blank');
      },
      (err: any) => {
        this.loading_link = false;
        console.log(err);
      }
    );
  }

  abrirLinkpagamento(link = null) {
    link = (link === null) ? this.link : link.pagarme_payment_link_url;
    window.open(link, '_blank');

    const msg = '';
    const inner_msg = ''
    + '<center><p>Após ter efetuado o pagamento no site do provedor de pagamento, atualize esta página para validar a assinatura pré-paga.</p></center>'
    + '<center><p>Você terá acesso ao conteudo especial no seu aparelho celular. </p></center>';


    const dialogRef = this.dialog.open(DialogLinkComponent, {
      width: '360px',
      data: {
        title: 'Atualizar Página',
        message: msg,
        inner_msg: inner_msg,
        bt_ok: 'Sim', 
        bt_cancel: 'Não',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result === 'ok') {
        window.location.reload();
      }
    });    
  }

  pagVoltar() {
    this.plan = null;
    setTimeout(() => {
      this.getAccount();
    }, 60000);
  }

  getUserFormValidationMessage(el: any) {
    if (el.errors.required) {
      return 'Este campo é obrigatório';
    }

    if (el.errors.incorrect || el.errors.pattern) {
      return 'O valor deste campo é inválido';
    }
  }

  validateAllFormFields(formGroup: FormGroup) {         //{1}
    Object.keys(formGroup.controls).forEach(field => {  //{2}
      const control = formGroup.get(field);             //{3}
      // console.log(control);
      // console.log(field);
      if (field !== 'line_2') {
        if (control instanceof FormControl) {             //{4}
          control.markAsTouched({ onlySelf: true });
        } else if (control instanceof FormGroup) {        //{5}
          this.validateAllFormFields(control);            //{6}
        }
      }
    });
  }

  limparCampos() {
    const plano = this.cardForm.value.supertreinos_plan_id;
    this.cardForm.reset();
    this.cardForm.patchValue({supertreinos_plan_id: plano, phone: {country_code: '55'}, address: { country: 'BR'}});
  }

  cardMoc() {
    const data: any = {
      cpf: '44154758764',
      name: 'Aardvark Silva',
      // number: '4018720572598048',
      number: '4000000000000010',
      cvv: '123',
      month_late: '11',
      year_late: '30',
      phone : {
        country_code: '55',
        area_code: '21',
        number: '988887777',        
      },
      address: {
        country: 'BR',
        state: 'RJ',
        city: 'Rio de Janeiro',
        line_1: 'Av Atlantica 100',
        line_2: '',
        zip_code: '25123456',
      }

    }
    this.cardForm.patchValue(data);
  }


  // verificar se esta sendo usado de fato -> componente correto é professores.component.ts
  pay() {
    // console.log(this.cardForm.value); return false;
    this.validateAllFormFields(this.cardForm);
    if (this.validateSubscribeData() === false) return false;

    if (this.helpers.TestaCPF(this.cardForm.value.cpf) === false) {
      this.toastr.error('CPF inválido!', '', this.helpers.toastrCfgs);
      return false;
    }
    if ((this.cardForm.value.address.zip_code).length !== 8) {
      this.toastr.error('CEP inválido com menos de 8 números!', '', this.helpers.toastrCfgs);
      return false;
    }
    if ((this.cardForm.value.address.zip_code).indexOf('-') > 0) {
      this.toastr.error('CEP inválido', '', this.helpers.toastrCfgs);
      return false;
    }

    const dataString = JSON.stringify(this.cardForm.value);
    const data = JSON.parse(dataString);
    data.token = this.captcha;

    // console.log(data);
    // return false;

    this.loading = true;
    this.purchase.createSubscription(data).then(
      (res: any) => {
        // console.log(res);
        this.user = res.user;
        this.loading = false;
        this.getSubscription();
        this.setPremiumExpiration();
        this.alert = { type: 'success', msg: 'Assinatura criada com sucesso! '}
        this.toastr.success('Maravilha! Acesso premium liberado, agora vamos treinar de verdade!', '', this.helpers.toastrCfgs);
      },
      (err: any) => {
        this.loading = false;
        this.alert = { type: 'danger', msg: 'Não foi possível processar o pagamento'}
        err = JSON.parse(err.toString().replace('Error: ', ''));
        // console.log(err);
        if (err.errAdm) {
          // console.log(err.errAdm);
          const dialogRef = this.dialog.open(DialogLinkComponent, {
            width: '70vw',
            maxWidth: '360px',
            data: { inner_msg: err.errAdm, title: err.cap, bt_ok: err.btok, url: err.bturl, show_alert: true } });
          dialogRef.afterClosed().subscribe(_result => {
            if (_result === 'ok') {
              // if (err.bturl) {
              //   window.open(err.bturl, '_blank');
              // }
            }
          });
        } else {
          console.log(err);
          this.toastr.error('O sistema retornou um erro. Tente novamente mais tarde ou entre em contato com o suporte.', '', this.helpers.toastrCfgs);
        }
      }
    );

  }

  cancel() {
    const msg = '';
    const inner_msg = ''
    + '<center><p><b>Esta é sua Assinatura Premium.</b></p></center>'
    + '<center><p><b>Ao cancelar a assinatura, sua conta passará a ser gratuita.</b></p></center>'
    + '<center><p><b>Você perderá acesso ao conteudo especial. Tem certeza que deseja prosseguir?.</b></p></center>';


    const dialogRef = this.dialog.open(DialogLinkComponent, {
      width: '360px',
      data: {
        title: 'Cancelar Assinatura',
        message: msg,
        inner_msg: inner_msg,
        bt_ok: 'Sim', 
        bt_cancel: 'Não',
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log(result);
      if (result === 'ok') {
        this.loading = true;
        this.purchase.cancelSubscription().then(
          (res: any) => {
            // console.log(res);
            this.user = res.user;
            this.loading = false;
            this.getSubscription();
            this.alert = { type: 'cancel', msg: 'Assinatura cancelada'}
            this.toastr.success('Seu plano foi cancelado.', '', this.helpers.toastrCfgs);
          },
          (err: any) => {
            this.loading = false;
            console.log(err);
            this.toastr.error('O sistema retornou um erro. Tente novamente mais tarde ou entre em contato com o suporte.', '', this.helpers.toastrCfgs);
          }
        );
    
      }
    });

  }

  updatePagarme() {
    this.validateAllFormFields(this.cardForm);
    if (this.validateSubscribeData() === false) return false;

    if (this.helpers.TestaCPF(this.cardForm.value.cpf) === false) {
      this.toastr.error('CPF inválido!', '', this.helpers.toastrCfgs);
      return false;
    }

    const dataString = JSON.stringify(this.cardForm.value);
    const ds = JSON.parse(dataString);
    const pagarme = {'pagarme' : {
      'customer_id' : this.pagarme.customer.id,
      'card_id': this.pagarme.card.id,
      'subscription_id': this.pagarme.subscription.id,
    }};
    const data = Object.assign(ds, pagarme);
    // console.log(this.pagarme);
    // console.log(data);
    // return false;

    this.loading = true;
    this.purchase.updatePagarme(data).then(
      (user: any) => {
        this.alert = { type: 'success', msg: 'Assinatura atualizada com sucesso! '}
        this.toastr.success('Seus dados foram atualizados com sucesso!', '', this.helpers.toastrCfgs);
        this.loading = false;
      },
      (err: any) => {
        this.alert = { type: 'danger', msg: 'Não foi possível atualizar o meio de pagamento!'}
        this.loading = false;
        console.log(err);
      }
    ); 
  }

  validateSubscribeData(update: boolean = false) {
    if (this.helpers.TestaCPF(this.cardForm.value.cpf) === false) {
      this.toastr.error('CPF inválido', '', this.helpers.toastrCfgs);
      return false;
    }

    if (this.cardForm.value.number === '' || this.cardForm.value.number === null) {
      this.toastr.error('O número do cartão de crédito está em branco!', '', this.helpers.toastrCfgs);
      return false;
    }
    if ((this.cardForm.value.number).indexOf('*') > -1 && update) {
      this.toastr.error('O número do cartão de crédito está incorreto!', '', this.helpers.toastrCfgs);
      return false;
    }
    if (this.cardForm.value.cvv === '' || this.cardForm.value.cvv === null) {
      this.toastr.error('O código de segurança do cartão de crédito está em branco!', '', this.helpers.toastrCfgs);
      return false;
    }
    if ((this.cardForm.value.cvv).indexOf('*') > -1 && update) {
      this.toastr.error('O código de segurança está incorreto!', '', this.helpers.toastrCfgs);
      return false;
    }
    if (this.cardForm.value.month_late === '' || this.cardForm.value.month_late === null) {
      this.toastr.error('O campo do mês de expiração do cartão de crédito está em branco!', '', this.helpers.toastrCfgs);
      return false;
    }
    if (this.cardForm.value.year_late === '' || this.cardForm.value.year_late === null) {
      this.toastr.error('O campo do ano de expiração do cartão de crédito está em branco!', '', this.helpers.toastrCfgs);
      return false;
    }

    if (this.cardForm.value.phone.country_code === '' || this.cardForm.value.phone.country_code === null) {
      this.toastr.error('O código do país / DDI não pode ficar em branco', '', this.helpers.toastrCfgs);
      return false;
    }
    if (this.cardForm.value.phone.area_code === '' || this.cardForm.value.phone.area_code === null) {
      this.toastr.error('O código de área / DDD não pode ficar em branco', '', this.helpers.toastrCfgs);
      return false;
    }
    if (this.cardForm.value.phone.number === '' || this.cardForm.value.phone.number === null) {
      this.toastr.error('O número do telefone não pode ficar em branco', '', this.helpers.toastrCfgs);
      return false;
    }
    if (this.cardForm.value.address.country === '' || this.cardForm.value.address.country === null) {
      this.toastr.error('O campo país não pode ficar em branco', '', this.helpers.toastrCfgs);
      return false;
    }
    if (this.cardForm.value.address.state === '' || this.cardForm.value.address.state === null) {
      this.toastr.error('O campo estado não pode ficar em branco', '', this.helpers.toastrCfgs);
      return false;
    }
    if (this.cardForm.value.address.city === '' || this.cardForm.value.address.city === null) {
      this.toastr.error('O campo cidade não pode ficar em branco', '', this.helpers.toastrCfgs);
      return false;
    }
    if (this.cardForm.value.address.line_1 === '' || this.cardForm.value.address.line_2 === null) {
      this.toastr.error('Informe o nome da rua e número', '', this.helpers.toastrCfgs);
      return false;
    }
    if (this.cardForm.value.address.zip_code === '' || this.cardForm.value.address.zip_code === null) {
      this.toastr.error('O CEP não pode ficar em branco', '', this.helpers.toastrCfgs);
      return false;
    }
    return true;    
  }  

  getPaymentList() {
    this.loading_prepaid = true;
    this.purchase.getListPaymentLink(5).then(
      (res: any) => {
        this.payment_links = res.payment_links;
        this.loading_prepaid = false;
      },
      (err: any) => {
        console.log(err);
        this.loading_prepaid = false;
      }
    );
  }

  validateEmail() {
    // console.log(this.user);

    this.loading = true;
    this.auth.requestValidEmailCustomer().then(
      (res: any) => {
        console.log(res);
        this.loading = false;
        this.toastr.success('O email de validação foi enviado!', '', this.helpers.toastrCfgs);
      },
      (err: any) => {
        console.log(err);
        this.loading = false;
      }
    );
  }

}
